/* eslint-disable react/no-unused-state */
import { Component } from 'react';
import PropTypes from 'prop-types';
import DOM from './pieChartWithCustomizedLabel';

class PieChartWithCustomizedLabel extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;
        this.state = {
            activeIndex: 0,
            timeframe: props.timeframe,
            mouseOnChart: false,
            colors: [
                '#FCB525',
                '#82C4FD',
                '#7AC943',
                '#F77B00',
                '#ED1C24',
                '#8158B9',
                '#E062D3',
                '#176C89',
                '#8C28A3',
                '#B31617',
                '#54D193',
                '#17A92F',
                '#C270E0',
                '#0DDF3A',
                '#DAE63B',
                '#501CCA',
                '#FF5365',
                '#D8E849',
                '#F27AC2',
                '#E6F9F4',
                '#660787',
            ],
        };
    }

    onTimeframeChange(timeframe) {
        const { onTimeframeChange } = this.props;

        this.setState({
            timeframe,
        });

        onTimeframeChange(timeframe);
    }

    onPieEnter(data, index) {
        this.setState({
            activeIndex: index,
            mouseOnChart: true,
        });
    }

    onPieLeave() {
        this.setState({
            mouseOnChart: false,
        });
    }

    render() {
        return this.view();
    }
}

PieChartWithCustomizedLabel.defaultProps = {
    onTimeframeChange: () => null,
    rightMenuOnClick: () => null,
    rightMenuItems: [],
    tooltipText: null,
    onFirstOptionChange: () => null,
    onSecondOptionChange: () => null,
    onThirdOptionChange: () => null,
    onFourOptionChange: () => null,
    onAllOptionChange: () => null,
    defaultFirstOptionValue: 'All',
    defaultSecondOptionValue: 'All',
    defaultThirdOptionValue: 'All',
    defaultFourOptionValue: 'All',
    divisions: [],
    userDivisions: [],
    drivers: [],
    assets: [],
    data: [],
    dataKey: 'value',
    fill: '#FDCE7D',
    heightRatio: 1,
    showLabelAndValue: '',
    dotOnClick: () => null,
};

PieChartWithCustomizedLabel.propTypes = {
    timeframe: PropTypes.oneOf(['hourly', 'daily', 'weekly', 'monthly', 'yearly']).isRequired,
    data: PropTypes.array,
    dataKey: PropTypes.string,
    rightMenuItems: PropTypes.array,
    onTimeframeChange: PropTypes.func,
    rightMenuOnClick: PropTypes.func,
    tooltipText: PropTypes.string,
    onFirstOptionChange: PropTypes.func,
    onSecondOptionChange: PropTypes.func,
    onThirdOptionChange: PropTypes.func,
    onFourOptionChange: PropTypes.func,
    onAllOptionChange: PropTypes.func,
    defaultFirstOptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultSecondOptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultThirdOptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultFourOptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    divisions: PropTypes.array,
    userDivisions: PropTypes.array,
    drivers: PropTypes.array,
    assets: PropTypes.array,
    fill: PropTypes.string,
    heightRatio: PropTypes.oneOf([1, 2]),
    showLabelAndValue: PropTypes.string,
    dotOnClick: PropTypes.func,
};

export default PieChartWithCustomizedLabel;
